export const onboarding = 'onboarding'
export const wordings = 'wordings.'
export const title = 'title'
export const subtitle = 'subtitle'
export const content = 'content'
export const info = 'info'
export const options = 'options'
export const label = 'label'
